/**
 * CLAVIS CYBER Wordmark.
 * Renders the brand wordmark "clavis/cyber".
 *
 * Color tokens (DESIGN.md):
 *   - ink     → oklch(15% 0.005 80)
 *   - paper   → oklch(98% 0.003 80)
 *   - brass   → oklch(70% 0.13 80)
 *
 * Variants:
 *   - "light" (default) → ink wordmark on paper background, brass slash
 *   - "dark"            → paper wordmark on ink background, brass slash
 *   - "gold"            → full-brass wordmark (legacy alias)
 *   - "mono"            → currentColor (use with text-* utilities)
 *
 * The component inherits its size from the surrounding text utility classes
 * (e.g. <Wordmark className="text-2xl" />) — no fixed width/height.
 */
const TOKENS = {
  ink: 'oklch(15% 0.005 80)',
  paper: 'oklch(98% 0.003 80)',
  brass: 'oklch(70% 0.13 80)',
};

export const Wordmark = ({ variant = 'light', className = '', as: As = 'span' }) => {
  const base = 'font-sans tracking-tight inline-block leading-none';
  const slash = { fontWeight: 400 };

  if (variant === 'dark') {
    return (
      <As className={`${base} ${className}`} style={{ fontWeight: 500 }}>
        <span style={{ color: TOKENS.paper }}>clavis</span>
        <span style={{ color: TOKENS.brass, ...slash }}>/</span>
        <span style={{ color: TOKENS.paper }}>cyber</span>
      </As>
    );
  }
  if (variant === 'gold') {
    return (
      <As className={`${base} ${className}`} style={{ fontWeight: 500, color: TOKENS.brass }}>
        <span>clavis</span>
        <span style={slash}>/</span>
        <span>cyber</span>
      </As>
    );
  }
  if (variant === 'mono') {
    return (
      <As className={`${base} ${className}`} style={{ fontWeight: 500 }}>
        <span>clavis</span>
        <span style={slash}>/</span>
        <span>cyber</span>
      </As>
    );
  }
  return (
    <As className={`${base} ${className}`} style={{ fontWeight: 500 }}>
      <span style={{ color: TOKENS.ink }}>clavis</span>
      <span style={{ color: TOKENS.brass, ...slash }}>/</span>
      <span style={{ color: TOKENS.ink }}>cyber</span>
    </As>
  );
};

export default Wordmark;
